import { useMemo } from 'react';
import { NavObject } from '@usacsmideo/types';
import { getValidScreenArray } from '../data/navigation/getValidScreenArray';

export function useIsTerminalScreen(currentPath: string, navObj: NavObject | undefined): boolean {
  return useMemo(() => {
    if (!navObj) return false;
    const screenArray = getValidScreenArray(navObj, 'useIsTerminalScreen');
    const currentIndex = screenArray.findIndex((screen) => screen.path === currentPath.slice(1));
    if (currentIndex === -1) return false;
    return currentIndex === screenArray.length - 1;
  }, [currentPath, navObj]);
}
